import axios from "axios";
import {API} from "@/env";
import Vuex from "@/store";

export default {

    /**
     * Show Events,
     * @param,
     * @api {POST} web/allorginizerevents,
     * @param event_id
     */
    show_event(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/showEvent',
            headers: {'content-type': 'application/json'},
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response)
            })
        })
    },

    /**
     * Show Events,
     * @param,
     * @api {GET} api/web/popularEvent,
     */
    show_popular() {
        const options = {
            method: 'GET',
            url: API + 'api/web/popularEvent',
            headers: {'content-type': 'application/json'},
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },

    /**
     * My Subscriptions Events,
     * @api {GET} api/web/mySubscriptions,
     * @data data
     */
    mySubscriptions(data) {
        const options = {
            method: 'GET',
            url: API + 'api/web/mySubscriptions',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },

    /**
     * Subscribe On Events
     * @api {GET} api/web/subscripe,
     * @data data
     */
    Subscribe_Event(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/subscripe',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token},
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },


    /**
     * Subscribe Status
     * @api {GET} /api/web/subscriptionStatus,
     * @data data
     */
    Subscribe_status(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/subscriptionStatus',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data,
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data)
                })
        })
    },

    /**
     * Check user is paid or no,
     * @param,
     * @api {POST}
     * @param user_id
     */
     subscribe_payment(data) {
        const options = {
            method: 'POST',
            url: API + 'api/web/submit-payment',
            headers: {'content-type': 'application/json', Authorization: 'Bearer ' + Vuex.getters.token },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response)
                })
        })
    },
}